<template>
  <div class="s-curve-component">
    <div class="container"> 
      <!-- 主要S型曲线容器 -->
      <div class="curve-container" ref="homeContainer">
        <!-- 灰色底线 -->
        <!-- <svg class="gray-curve" viewBox="-200 0 1800 1893" preserveAspectRatio="none">
            <path id="gray-path" d="M-200 5C512 15 1550 159 1150 
                    328C800 451.944 -149.5 507.5 
                    100 675.5C350 843.5 1350 
                    978.228 1100 1122C800 1292 -271.4029 
                    1227.51 400 1498C900 1684.5 1100 
                    1818.5 800 1887.5" 
                stroke="#e0e0e0" stroke-width="5"/>
        </svg> -->
        <!-- <svg class="gray-curve" viewBox="0 0 1586 2527" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1031 2527C927.374 2496.71 829.651 2449.37 733.822 2400.14C710.181 2387.8 686.722 2375.11 663.487 2362.05C610.441 2332.06 564.505 2304.67 516.251 2269.92C473.116 2235.46 414.335 2199.9 416.639 2141C423.12 2113.28 451.919 2098.47 477.924 2087.29C503.676 2076.63 533.063 2068.78 559.969 2062.61C616.153 2049.9 673.129 2041.39 730.22 2033.16C956.254 1997.47 1196.26 1989.08 1398.96 1869.75C1424.7 1852.43 1449.27 1828.95 1451.83 1796.1C1453.86 1763.47 1434.63 1735.9 1414.55 1713.38C1373.37 1669.02 1321.75 1635.91 1270.82 1604.86C1168.03 1543.61 1059.5 1491.96 951.826 1440.59C738.38 1335.53 509.155 1249.13 327.941 1097.45C306.474 1077.06 289.188 1054.35 285.619 1027.93C281.862 1001.65 295.952 975.8 315.396 955.548C354.513 915.47 408.489 888.127 461.122 863.787C567.636 816.045 680.589 780.654 792.697 746.239C1017.22 676.005 1248.26 624.224 1463.72 521.869C1515.62 492.286 1595.35 455.917 1585.04 373.728C1561.72 301.873 1494.05 274.433 1438.48 245.801C1321.08 192.399 1197.73 160.45 1073.93 131.692C825.862 76.0482 574.15 41.2841 321.26 18.7358C213.465 9.38021 105.275 2.63038 -2.65627 -0.000213623C-2.88542 10.664 -3.11458 21.3282 -3.34373 31.9924C103.736 34.0699 211.389 40.2473 318.698 49.0276C570.448 70.2129 821.496 103.646 1068.08 157.69C1191.01 185.561 1313.8 216.923 1428.06 268.271C1482.14 294.296 1546.29 326.656 1561.78 378.927C1572.47 432.645 1504.91 474.107 1453.24 501.512C1243.28 602.671 1011.29 656.416 787.004 727.69C674.773 762.766 561.633 798.761 453.781 847.728C400.371 872.873 345.566 900.384 303.171 944.045C282.253 965.951 264.574 997.054 269.409 1030.06C274.195 1062.81 294.286 1087.46 317.055 1109.06C504.128 1263.81 732.317 1347.43 946.549 1451.78C1054.38 1502.56 1162.99 1553.62 1265.38 1613.96C1316.06 1644.47 1367.44 1677.27 1407.36 1719.92C1426.96 1741.51 1444.37 1767.44 1442.59 1795.44C1440.7 1823.54 1418.9 1845.61 1394.04 1862.42C1195.9 1980.66 955.188 1991.2 729.442 2027.8C672.34 2036.33 615.323 2045.13 558.942 2058.17C531.936 2064.52 502.406 2072.53 476.331 2083.47C450.105 2095.03 420.185 2109.89 413.01 2140.25C411.433 2203.96 471.252 2237.41 514.581 2272.23C563.161 2306.86 609.284 2334.03 662.513 2363.79C685.831 2376.75 709.369 2389.33 733.085 2401.56C829.211 2450.34 927.212 2497.22 1031 2527Z" fill="white"/>
        </svg> -->
        <svg class="gray-curve" viewBox="0 0 1652 1994" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-2.65637 -0.00021553C-2.88546 10.664 -3.11454 21.3282 -3.34363 31.9924C83.9543 33.6285 171.17 38.1993 258.465 44.6229C523.967 64.7672 788.527 99.5311 1049.34 152.503C1179.35 179.548 1309.64 210.638 1433.4 256.08C1494.48 279.495 1558.56 305.541 1604.61 348.341C1627.65 369.834 1638.94 399.332 1621.61 423.98C1604.34 449.539 1578.53 465.401 1547.74 481.804C1324.81 588.996 1082.29 654.346 846.567 735.007C728.2 774.766 610.492 814.866 495.045 864.357C437.647 889.532 380.883 915.706 329.212 952.945C304.867 971.576 277.041 993.776 269.421 1027.89C262.639 1064.98 292.87 1091.23 319.487 1108.14C495.01 1209.02 692.851 1255.08 884.79 1310.04C981.323 1336.47 1078.6 1361.84 1174.11 1389.72C1222.3 1403.96 1269.91 1418.41 1316.51 1436.78C1339.57 1446.24 1363.39 1455.98 1382.2 1471.45C1386.33 1474.96 1391.05 1480.33 1392.4 1484.9C1393.28 1487.66 1393.3 1490.25 1392.47 1492.84C1391.75 1495.09 1390.33 1497.42 1388.08 1499.81C1385.87 1502.1 1384.19 1503.42 1381.6 1505.24C1380.35 1506.1 1378.99 1506.97 1377.51 1507.83C1376.78 1508.26 1376.01 1508.69 1375.22 1509.12C1374.62 1509.45 1374.05 1509.75 1373.45 1510.07C1368.64 1512.56 1362.89 1515.04 1356.18 1517.48C1218.54 1568.68 1084.2 1641.18 986.719 1753.03C929.669 1818.95 890.217 1905.61 899.274 1994C890.773 1905.55 930.678 1819.44 987.934 1754.07C1085.77 1643.17 1220.17 1571.69 1357.64 1521.51C1364.5 1519.05 1370.42 1516.55 1375.46 1513.98C1376.09 1513.66 1376.69 1513.35 1377.32 1513.01C1378.16 1512.56 1378.96 1512.11 1379.74 1511.66C1381.3 1510.75 1382.76 1509.84 1384.12 1508.92C1386.93 1506.96 1388.8 1505.54 1391.35 1502.92C1393.98 1500.17 1395.82 1497.28 1396.82 1494.25C1397.97 1490.79 1397.95 1487.06 1396.81 1483.49C1395.02 1477.54 1389.68 1471.67 1385.32 1467.88C1365.48 1451.41 1341.69 1441.69 1318.45 1431.96C1271.63 1413.17 1224.03 1398.42 1175.85 1383.86C1080.37 1355.36 983.235 1329.4 886.905 1302.39C695.642 1246.47 497.321 1198.51 325.707 1098.37C299.846 1081.9 275.505 1058.31 281.361 1030.15C287.213 1002.87 312.999 980.769 336.73 963.207C386.895 927.476 443.423 901.688 500.506 877.092C615.452 828.633 733.186 789.303 851.631 750.32C1087.91 670.996 1329.57 607.852 1557.2 500.188C1589.6 482.865 1617.24 467.535 1639.56 435.409C1650.23 419.291 1654.87 398.33 1649.44 379.256C1644.2 360.161 1632.52 345.341 1620 332.775C1568.37 284.589 1503.79 259.001 1441.53 234.453C1315.96 187.493 1185.17 155.522 1054.56 127.506C792.659 72.6615 527.534 36.1872 260.795 14.3124C173.084 7.32263 85.3863 2.18621 -2.65637 -0.00021553Z" fill="white"/>
        </svg>


        <!-- 彩色曲线 -->
        <!-- <svg class="color-curve" viewBox="-200 0 1800 1893" preserveAspectRatio="none">
            <defs>
                <linearGradient id="gradient" x1="824.204" y1="38.0253" x2="824.036" y2="1999.59" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#008BFF"/>
                  <stop offset="1" stop-color="#00FA91"/>
                </linearGradient>
            </defs>
            <path id="color-path" d="M-200 5C512 15 1550 159 1150 
                    328C800 451.944 -149.5 507.5 
                    100 675.5C350 843.5 1350 
                    978.228 1100 1122C800 1292 -271.4029 
                    1227.51 400 1498C900 1684.5 1100 
                    1818.5 800 1887.5" 
                stroke="url(#gradient)" stroke-width="5"/>
        </svg> -->
        <svg class="color-curve" viewBox="0 0 1652 1994" xmlns="http://www.w3.org/2000/svg">
          <defs>
                <linearGradient id="gradient" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#008BFF"/>
                  <stop offset="1" stop-color="#00FA91"/>
                </linearGradient>
            </defs>
          <path id="color-path" d="M1031 2527C927.374 2496.71 829.651 2449.37 733.822 2400.14C710.181 2387.8 686.722 2375.11 663.487 2362.05C610.441 2332.06 564.505 2304.67 516.251 2269.92C473.116 2235.46 414.335 2199.9 416.639 2141C423.12 2113.28 451.919 2098.47 477.924 2087.29C503.676 2076.63 533.063 2068.78 559.969 2062.61C616.153 2049.9 673.129 2041.39 730.22 2033.16C956.254 1997.47 1196.26 1989.08 1398.96 1869.75C1424.7 1852.43 1449.27 1828.95 1451.83 1796.1C1453.86 1763.47 1434.63 1735.9 1414.55 1713.38C1373.37 1669.02 1321.75 1635.91 1270.82 1604.86C1168.03 1543.61 1059.5 1491.96 951.826 1440.59C738.38 1335.53 509.155 1249.13 327.941 1097.45C306.474 1077.06 289.188 1054.35 285.619 1027.93C281.862 1001.65 295.952 975.8 315.396 955.548C354.513 915.47 408.489 888.127 461.122 863.787C567.636 816.045 680.589 780.654 792.697 746.239C1017.22 676.005 1248.26 624.224 1463.72 521.869C1515.62 492.286 1595.35 455.917 1585.04 373.728C1561.72 301.873 1494.05 274.433 1438.48 245.801C1321.08 192.399 1197.73 160.45 1073.93 131.692C825.862 76.0482 574.15 41.2841 321.26 18.7358C213.465 9.38021 105.275 2.63038 -2.65627 -0.000213623C-2.88542 10.664 -3.11458 21.3282 -3.34373 31.9924C103.736 34.0699 211.389 40.2473 318.698 49.0276C570.448 70.2129 821.496 103.646 1068.08 157.69C1191.01 185.561 1313.8 216.923 1428.06 268.271C1482.14 294.296 1546.29 326.656 1561.78 378.927C1572.47 432.645 1504.91 474.107 1453.24 501.512C1243.28 602.671 1011.29 656.416 787.004 727.69C674.773 762.766 561.633 798.761 453.781 847.728C400.371 872.873 345.566 900.384 303.171 944.045C282.253 965.951 264.574 997.054 269.409 1030.06C274.195 1062.81 294.286 1087.46 317.055 1109.06C504.128 1263.81 732.317 1347.43 946.549 1451.78C1054.38 1502.56 1162.99 1553.62 1265.38 1613.96C1316.06 1644.47 1367.44 1677.27 1407.36 1719.92C1426.96 1741.51 1444.37 1767.44 1442.59 1795.44C1440.7 1823.54 1418.9 1845.61 1394.04 1862.42C1195.9 1980.66 955.188 1991.2 729.442 2027.8C672.34 2036.33 615.323 2045.13 558.942 2058.17C531.936 2064.52 502.406 2072.53 476.331 2083.47C450.105 2095.03 420.185 2109.89 413.01 2140.25C411.433 2203.96 471.252 2237.41 514.581 2272.23C563.161 2306.86 609.284 2334.03 662.513 2363.79C685.831 2376.75 709.369 2389.33 733.085 2401.56C829.211 2450.34 927.212 2497.22 1031 2527Z"/>
        </svg>
        
        <!-- 内容节点 -->
        <div class="content-node content-node_1" data-node="1">
            <img class="content-node_1_line" src="@/assets/img/home/left_border.png" alt="">
            <div class="content-node_1_text_1">2005年</div>
            <div class="content-node_1_text_2">"绿水青山就是金山银山"</div>
            <div class="content-node_1_text_2">生态文明建设被提升到前所未有的战略高度</div>
            <!-- <img class="content-node_1_img" src="@/assets/img/home/earth.png" alt=""> -->
        </div>
        <div class="content-node content-node_2" data-node="2">
          <img class="content-node_1_line node_2_line" src="@/assets/img/home/left_border.png" alt="">
          <div class="content-node_1_text_1">2020年9月</div>
          <div class="content-node_1_text_2">我国向全球做出“3060”庄严承诺</div>
          <!-- <div class="content-node_1_text_2">2030年前碳达峰、2060年前碳中和目标</div> -->
        </div>
        <div class="content-node content-node_3" data-node="3">
          <img class="content-node_1_line node_2_line" src="@/assets/img/home/left_border.png" alt="">
          <div class="content-node_1_text_1">2021年12月26日</div>
          <div class="content-node_1_text_2">中碳写下模型的第一行代码与第一条语料</div>
        </div>
        <div class="content-node content-node_4" data-node="4">
          <img class="content-node_1_line node_2_line" src="@/assets/img/home/left_border.png" alt="">
          <div class="content-node_1_text_1">2024年7月30日</div>
          <div class="content-node_1_text_2">碳排放强度被正式列为“十五五”时期约束性指标</div>
        </div>
        <div class="content-node content-node_6" data-node="5">
          <img class="content-node_1_line node_2_line" src="@/assets/img/home/left_border.png" alt="">
          <div class="content-node_1_text_1">2024年11月18日</div>
          <div class="content-node_1_text_2">全球首个双碳领域专业大模型——”碳芯”获国家网信办备案登记通过</div>
        </div>
        <div class="content-node content-node_7" data-node="6">
          <img class="content-node_1_line node_2_line" src="@/assets/img/home/left_border.png" alt="">
          <div class="content-node_1_text_1">2025年10月9日</div>
          <div class="content-node_1_text_2">中碳AI Agent正式上线运行</div>
        </div>
        <!-- <div class="content-node content-node_10" data-node="10">
          <img class="content-node_10_img" src="@/assets/img/home/line_icon.png" alt="">
        </div> -->
        <div class="content-node content-node_11" data-node="7">
          <!-- <img class="content-node_1_line node_2_line" src="@/assets/img/home/left_border_other.png" alt=""> -->
          <div class="content-node_1_text_1">我们作为“双碳”战略的探索者与驱动者</div>
          <div class="content-node_1_text_2">以AI赋能，智领未来</div>
        </div>
      </div>
    </div>
    <Footer pageType="home" />
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import Footer from '@/components/footer/index.vue'

// 注册GSAP插件
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin)

export default {
  components: {
    Footer,
  },
  name: 'SCurveComponent',
  mounted() {
    this.$nextTick(() => {
      this.adjustCurveElements();
      this.initAnimations();
      window.addEventListener('resize', this.adjustCurveElements);
    });
  },
  methods: {
    adjustCurveElements() {
      const container = this.$refs.homeContainer;
      if (!container) return;      
      
      // 内容节点位置 - 从左侧开始
      const nodePositions = [
        { left: 13, top: -5 }, 
        { left: 48, top: 0 },  
        { left: 54, top: 18 },
        { left: 25, top: 29 },
        { left: 16, top: 51}, 
        { left: 52, top: 63 },
        // { left: 68.5, top: 69.5 },
        { left: 30, top: 89}
      ];
      
      document.querySelectorAll('.content-node').forEach((node, index) => {
        const pos = nodePositions[index];
        node.style.left = `${pos.left}%`;
        node.style.top = `${pos.top}%`;
      });
    },
  
    initAnimations() {
    // 获取元素
    const colorPath = document.getElementById('color-path');
    const homeContainer = this.$refs.homeContainer;
    const contentNodes = document.querySelectorAll('.content-node');      
    if (!colorPath || !homeContainer) return;
    
    // 计算曲线总长度
    const pathLength = colorPath.getTotalLength();
    
    // 设置描边动画的基础属性
    colorPath.style.strokeDasharray = pathLength;
    colorPath.style.strokeDashoffset = pathLength;
    
    // 获取父级滚动容器
    const scrollContainer = this.findScrollContainer(homeContainer);
    
    if (!scrollContainer) {
        return;
    }
    
    // 确保滚动容器有足够的滚动空间
    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
        return;
    }
    
    // 重新计算每个节点在线段路径上的位置
    const nodePathPositions = this.calculateNodePathPositions(contentNodes, colorPath, homeContainer);
    
    // 记录上一次的显示长度，用于检测回退
    let lastDisplayedLength = 0;
    
    // 曲线动画 - 沿路径从起点开始逐步显示
    ScrollTrigger.create({
        trigger: homeContainer,
        scroller: scrollContainer,
        start: 'top 100%',
        end: 'bottom 100%',
        scrub: true,
        onUpdate: (self) => {
            const progress = self.progress;
            // 计算当前应该显示的曲线长度
            const displayedLength = pathLength * progress;
            colorPath.style.strokeDashoffset = pathLength - displayedLength;
            // 检测是否是回退（线段颜色缩短）
            const isReversing = displayedLength < lastDisplayedLength;
            lastDisplayedLength = displayedLength;
            // 控制内容节点显示 - 基于路径位置
            contentNodes.forEach((node, index) => {
                const nodePathPosition = nodePathPositions[index];
                if (!nodePathPosition) return;
                // 计算当前显示位置与节点路径位置的距离
                const distanceToNode = Math.abs(displayedLength - nodePathPosition.pathLength);
                // 设置动态阈值，基于节点间距自动调整
                const threshold = this.calculateDynamicThreshold(index, nodePathPositions, pathLength);
                // 检查线段是否已经超过节点位置
                const hasPassedNode = displayedLength >= nodePathPosition.pathLength;
                // 检查是否有后续节点已经被经过（不是回退状态时）
                let hasPassedLaterNodes = false;
                if (!isReversing) {
                  for (let i = index + 1; i < contentNodes.length; i++) {
                    const laterNodePosition = nodePathPositions[i];
                    if (laterNodePosition && displayedLength >= laterNodePosition.pathLength) {
                      hasPassedLaterNodes = true;
                      break;
                    }
                  }
                }
                // 检查是否完全回退到起点（显示长度接近0）
                const isFullyReversed = isReversing && displayedLength < pathLength * 0.03;
                // 优化显示逻辑
                this.updateNodeVisibility(node, {
                    index,
                    hasPassedNode,
                    hasPassedLaterNodes,
                    isReversing,
                    isFullyReversed,
                    distanceToNode,
                    threshold,
                    displayedLength,
                    nodePathPosition,
                    pathLength
                });
            });
        }
    });
},

  // 计算动态阈值
  calculateDynamicThreshold(index, nodePathPositions, pathLength) {
      // 基础阈值，根据新的SVG高度调整
      let threshold = pathLength * 0.06; // 降低基础阈值以适应新高度
      
      // 如果是第一个节点，增加阈值以便更早显示
      if (index === 0) {
          threshold = pathLength * 0.08; // 降低第一个节点的阈值
      }
      // 如果是最后一个节点，增加阈值以便更持久显示
      else if (index === nodePathPositions.length - 1) {
          threshold = pathLength * 0.12; // 降低最后一个节点的阈值
      }
      // 对于中间节点，根据间距调整阈值
      else if (index > 0 && index < nodePathPositions.length - 1) {
          const prevPosition = nodePathPositions[index - 1];
          const nextPosition = nodePathPositions[index + 1];
          
          if (prevPosition && nextPosition) {
              const spacing = Math.abs(nextPosition.pathLength - prevPosition.pathLength);
              // 间距越小，阈值越小，显示更精确
              threshold = Math.min(pathLength * 0.08, spacing * 0.25); // 调整阈值计算
          }
      }
      
      return Math.max(pathLength * 0.04, threshold); // 确保最小阈值
  },

    // 新增方法：更新节点可见性
    updateNodeVisibility(node, params) {
      const {
        index,
        hasPassedNode,
        hasPassedLaterNodes,
        isReversing,
        isFullyReversed,
        distanceToNode,
        threshold,
        displayedLength,
        nodePathPosition,
        pathLength
      } = params;
      
      // 获取排序后的索引（如果存在）
      const sortedIndex = nodePathPosition.sortedIndex || index;
      
      // 优先检查：如果点位已经被经过且不是回退状态，直接设为1
      if (hasPassedNode && !isReversing) {
        node.style.opacity = '1';
        return; // 直接返回，避免后续逻辑干扰
      } 
      // 其次检查：如果有后续节点已经被经过，且不是回退状态，当前节点也保持显示
      // 但需要确保当前节点已经被经过，避免过早显示
      else if (hasPassedLaterNodes && !isReversing && hasPassedNode) {
        node.style.opacity = '1';
        return; // 直接返回，避免后续逻辑干扰
      }
      // 然后检查：回退状态的处理
      else if (isReversing && hasPassedNode) {
        // 回退时，如果已经超过节点位置，保持显示但降低透明度
        const reverseDistance = displayedLength - nodePathPosition.pathLength;
        const reverseThreshold = threshold * 1.2; // 降低回退阈值
        
        // 如果是第一个节点（排序后的第一个）且完全回退到起点，则隐藏
        if (sortedIndex === 0 && isFullyReversed) {
          node.style.opacity = '1';
        } 
        // 当回退距离在阈值内时，从1开始逐渐降低到0
        else if (reverseDistance <= reverseThreshold) {
          const reverseStrength = 1 - (reverseDistance / reverseThreshold);
          node.style.opacity = Math.max(0, reverseStrength); // 从1降到0
        } 
        // 当回退距离超过阈值时，节点应该保持完全显示（opacity=1）
        else {
          node.style.opacity = '1';  // 修复：回退开始时从1开始
        }
        return; // 直接返回，避免后续逻辑干扰
      }
      // 再检查：距离阈值内的显示
      else if (distanceToNode <= threshold) {
        // 计算显示强度：距离越近，显示越强
        const displayStrength = 1 - (distanceToNode / threshold);
        node.style.opacity = displayStrength;
        return; // 直接返回，避免后续逻辑干扰
      }
      // 最后：早期显示逻辑（仅对前几个节点）
      else {
        // 线段还未到达节点位置
        // 使用排序后的索引来判断前几个节点
        if (sortedIndex <= 1 && displayedLength > pathLength * 0.02) { // 降低早期显示阈值
          // 对于前2个节点（排序后的前2个），当动画开始后立即显示
          const earlyProgress = Math.min(1, (displayedLength - pathLength * 0.02) / (nodePathPosition.pathLength - pathLength * 0.02));
          node.style.opacity = earlyProgress * 0.8; // 提高初始透明度
        } else {
            node.style.opacity = '0';
        }
      }
    },

    // 改进方法：计算每个节点在线段路径上的位置
    calculateNodePathPositions(contentNodes, path, container) {
      const containerRect = container.getBoundingClientRect();
      const pathLength = path.getTotalLength();
      const viewBox = { x: 0, y: 0, width: 1652, height: 1994 }; 
      
      // 首先计算所有节点的路径位置
      const nodePositions = Array.from(contentNodes).map((node, index) => {
          const nodeRect = node.getBoundingClientRect();
          // 计算节点相对于容器的中心点
          const nodeCenterX = nodeRect.left - containerRect.left + nodeRect.width / 2;
          const nodeCenterY = nodeRect.top - containerRect.top + nodeRect.height / 2;
          
          // 在路径上找到距离节点中心最近的点
          let closestPoint = null;
          let closestDistance = Infinity;
          let closestPathLength = 0;
          
          // 增加采样点数以提高精度
          const samples = 200;
          for (let i = 0; i <= samples; i++) {
            const pathProgress = i / samples;
            const pathPoint = path.getPointAtLength(pathLength * pathProgress);
            // 正确转换SVG坐标到容器坐标
            const svgPointX = (pathPoint.x - viewBox.x) * (containerRect.width / viewBox.width);
            const svgPointY = (pathPoint.y - viewBox.y) * (containerRect.height / viewBox.height);
            
            const distance = Math.sqrt(
              Math.pow(svgPointX - nodeCenterX, 2) + 
              Math.pow(svgPointY - nodeCenterY, 2)
            );
            
            if (distance < closestDistance) {
              closestDistance = distance;
              closestPoint = pathPoint;
              closestPathLength = pathLength * pathProgress;
            }
          }
          
          return {
            pathLength: closestPathLength,
            distance: closestDistance,
            nodeIndex: index,
            node: node
          };
      });
      
      // 按照路径长度排序，确保节点按照路径顺序显示
      nodePositions.sort((a, b) => a.pathLength - b.pathLength);
      
      // 返回排序后的结果，保持原始节点索引对应关系
      return nodePositions.map((pos, newIndex) => ({
        pathLength: pos.pathLength,
        distance: pos.distance,
        nodeIndex: pos.nodeIndex,
        originalIndex: pos.nodeIndex, // 保留原始索引用于调试
        sortedIndex: newIndex // 排序后的新索引
      }));
    },

    findScrollContainer(element) {
      let parent = element.parentElement;
      while (parent) {
        // 检查是否有scrollable类（这是Home.vue中设置的）
        if (parent.classList && parent.classList.contains('scrollable')) {
          return parent;
        }
        
        // 检查CSS overflow属性
        const style = window.getComputedStyle(parent);
        if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
          return parent;
        }
        
        // 检查是否是section-3-container
        if (parent.classList && parent.classList.contains('section-3-container')) {
          return parent;
        }
        
        parent = parent.parentElement;
      }
      return window;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustCurveElements);
  }
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  max-width: none;
  margin: 0; 
  padding: 0; 
  width: 100vw;
}

/* S曲线容器 */
.curve-container {
  position: relative;
  width: 100%;
  max-width: 100vw;
  height: 1994px;
  min-height: 1994px;
  max-height: 1994px;
  // margin: 50px auto 0;
  margin-top: calc(100vh * 50 / 1080);
  overflow: visible;
}

/* 曲线SVG容器 */
.gray-curve, .color-curve {
  position: absolute;
  top: 0;
  left: -160px;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.gray-curve path {
  stroke: #fff;
  // stroke-width: 10;
  // fill: none;
  stroke-linecap: round;
}

.color-curve path {
  stroke: transparent;
  stroke-width: 10;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  // stroke-dasharray: 1;
  // stroke-dashoffset: 1;
}

/* 内容节点 */
.content-node {
  position: absolute;
  /* width:20px;
  height:20px; */
  z-index: 9999;
  opacity: 0;
  display: flex;
  /*transform: translateY(20px) scale(0.95);
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1); */
}

.content-node_1{
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-weight: 400;
    position: relative;
    opacity: 1 !important;

    .content-node_1_img{
        width: 109px;
        height: 109px;
    }
}

.content-node_1_line{
    width: 3px;
    height: calc(100vh * 516 / 1080);
    position: absolute;
    top: 0;
    left: 52px;

    &.node_2_line{
        height: calc(100vh * 420 / 1080);
    }
}

.content-node_2{
  width: 570px;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 3px;
}

.moreClass{
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 2px;
  color: #fff;
  text-align: right;
}

.moreClass_6{
  color: #fff;
}

.moreClass_9{
  color: #fff;
}

.moreClass_10{
  color: #fff;
}

.moreClass_11{
  color: #fff;
}

.content-node_3{
  width: 700px;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
  letter-spacing: 2px;
}

.content-node_4{
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;

  .content-node_4_text_1{
      font-size: 36px;
      font-weight: 700;
      margin-left:68px;
  }
  .content-node_4_text_2{
      font-size: 28px;
      font-weight: 400;
      margin-left:68px;
      letter-spacing: 3px;
  }
}

.content-node_5{
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 2px;
}

.content-node_6{
  width:860px;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 2px;
}

.content-node_7{
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;

  .content-node_7_text_1{
      font-size: 36px;
      font-weight: 700;
      color: #fff;
  }
  .content-node_7_text_2{
      font-size: 28px;
      font-weight: 400;
      letter-spacing: 3px;
      color: #fff;
  }
}

.content-node_8{
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 2px;
}

.content-node_9{
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 2px;
}

.content-node_10{
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;

  .content-node_10_text_1{
      font-size: 36px;
      font-weight: 700;
  }
  .content-node_10_text_2{
      font-size: 28px;
      font-weight: 400;
      letter-spacing: 3px;
  }

  .content-node_10_img{
    width:120px;
    height: 130px;
  }
}

.content-node_1_text_1{
    font-size: 32px;
    margin-left:86px;
    line-height: 32px;
}

.content-node_1_text_1::after{
    content: "·";
    position: absolute;
    top: 0;
    left: 66px;
    width: 100%;
    height: 100%;
}

.content-node_1_text_2{
    font-size: 24px;
    margin-left:86px;
}

.content-node_11{
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: rgba(93, 148, 131, 1);
  font-weight: 400;
  text-align: center;

  .content-node_1_text_1{
    font-size: 32px;
    margin-left:86px;
    line-height: 32px;
  }

  .content-node_1_text_1::after{
      content: "·";
      position: absolute;
      top: 0;
      left: 66px;
      width: 100%;
      height: 100%;
  }

  .content-node_1_text_2{
      font-size: 48px;
      margin-left:86px;
  }
}
</style>